import { useI18n } from 'vue-i18n';
import locales from '@eureka/shared/locales/main';

export const setupI18n = () => {
  return useI18n({
    messages: locales,
  });
};
